export default {
  path: 'settings/activities',
  name: 'TemporaryRegulationsActivities',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ActivitiesIndex.vue')
}
